import React, { Component } from "react";

import { HomeSlider, HomeTitle, Img } from "../../Components/UI/UI";

import { getWeather } from "../../Utility/Utility";
import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "./Resources.css";
import "../innerPage.css";

const PageObj1 = {
  img: "Jerusalem.jpg",
  link: "http://www.holylandmagazine.com/2018/mobile/index.html",
};

const PageObj2 = {
  img: "Galilee.jpg",
  link: "http://www.holylandmagazine.com/",
};

class ContactUs extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    getWeather((Weather) => {
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    return (
      <div className="page align-center page-FAQ inner-page page-infoforpastors">
        <Menu />
        <HomeSlider
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />
        <div className="container">
          <HomeTitle>Resources</HomeTitle>
          <div className="clear"></div>

          <div className="resources-wrapper">
            {/* <a
              href="http://www.holylandmagazine.com/2018/mobile/index.html"
              target="_blank"
            >
              <Img desktopImg="resource2018.jpg" />
            </a>
            <a href="http://www.holylandmagazine.com/" target="_blank">
              <Img desktopImg="resource2020.jpg" />
            </a>
            
            <a href="http://holylandmagazine.com/" target="_blank">
              <Img desktopImg="resource2023.jpg" />
            </a> */}

            <a href="https://holylandmagazine.com/2018/mobile/index.html" target="_blank">
              <Img desktopImg="holylandmagazine2018.jpg" />
            </a>
            <a href="https://holylandmagazine.com/2019/" target="_blank">
              <Img desktopImg="holyandmagazin2019.jpg" />
            </a>
            <a href="https://holylandmagazine.com/2021/" target="_blank">
              <Img desktopImg="holylandmagazine2021.jpg" />
            </a>
            <a href="https://holylandmagazine.com/2022/" target="_blank">
              <Img desktopImg="holylandmagazine2022.jpg" />
            </a>
            <a href="https://holylandmagazine.com/" target="_blank">
              <Img desktopImg="holylandmagazine2023.jpg" />
            </a>
            <a href="https://itn.co.il/slideshow/?pid=494" target="_blank">
              <Img desktopImg="THEISRAELPILGRIMAGE.jpg" />
            </a>

            {/* <a href="https://itn.co.il/slideshow/?pid=494" target="_blank">
              <Img desktopImg="holylandmagazine2023.jpg" />
            </a> */}
          </div>
          <div className="clear"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/Pages/Resources/Resources.js